import React, { useState, useEffect } from 'react';
import axios from "axios";

const TopController = () => {
    const [getData, setGetData] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [addData, setAddData] = useState({ // フォームデータの初期状態
        date: "",
        title: "",
        content: ""
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("http://127.0.0.1:8000/api/news_items/");
                setGetData(response.data);
            } catch (error) {
                console.error('Newsデータ取得失敗', error);
            }
        }
        fetchData();
    }, [refreshFlag]);

    const createNewData = async (data) => {
        try {
            const formData = new FormData();
            for (const key in data) {
                formData.append(key, data[key]);
            }


            const response = await axios.post("http://127.0.0.1:8000/api/news_items/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            if (response.status === 201) {
                alert("追加に成功しました。");
                setRefreshFlag(!refreshFlag);
            } else {
                console.error("追加に失敗しました", error);
                alert('追加に失敗しました。');
            }
        } catch (error) {
            console.error("追加に失敗しました", error);
            alert("追加に失敗しました。");
        }

    }


    const deleteItem = async (id) => {
        try {
            const response = await axios.delete(`http://127.0.0.1:8000/api/news_items/${id}`);
            setRefreshFlag(!refreshFlag);
            if (response.status === 200) {
                alert("削除に成功しました。");
            } else {
                alert("削除に失敗しました。");
            }
        } catch (error) {
            console.error("削除エラー", error);
        }
    }

    const handleInputChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setAddData((prev) => ({ ...prev, [name]: value }));
        console.log(addData);
    }

    return (
        <div>
            <form onSubmit={(e) => {
                e.preventDefault();
                createNewData(addData);
            }}>
                <input type="date" name="date" value={addData.date} onChange={handleInputChange} /><br />
                <input type="text" name="title" value={addData.title} onChange={handleInputChange} /><br />
                <input type="text" name="content" value={addData.content} onChange={handleInputChange} /><br />
                <button type="submit">送信</button>

            </form>

            <h3>既存のデータ</h3>
            <ul>
                {getData.map((item) => (
                    <li key={item.id}>
                        {item.date} - {item.title} - {item.content} - <button id={item.id} onClick={() => { deleteItem(item.id) }}>削除</button>
                    </li>
                ))}
            </ul>



        </div>
    )
}
export default TopController;   